import _ from 'lodash';
import { useCallback, useMemo } from 'react';
import usePipeConfigs from 'v2/modules/withRunForm/hooks/usePipeConfigs/index';
import HoverMessage from 'common/components/HoverMessage';
import PipeConfigForm from './PipeConfigForm/index';
import PipeConfigView from './PipeConfigView/index';

const propTypes = {};
const defaultProps = {};

const PipeConfigs = () => {
  const {
    pipeConfigs,
    shouldRenderPipeForm,
    currentPipeConfig,
    onUpdatePipeFormConfigs,
    onUpdatePipeConfigsToStore,
    onAddIndicator,
    outputSchema,
    onDeletePipeConfig,
    onEditPipeConfig,
    existingPipeNames,
    editIndex,
    getPipeUpdatedNameIfAlreadyPresent,
    isHiddenSignal,
    errorConfigs
  } = usePipeConfigs();

  const onUpdate = useCallback((newPipeConfig) => {
    if (!_.isEmpty(newPipeConfig)) {
      onUpdatePipeConfigsToStore(newPipeConfig);
    }
    onUpdatePipeFormConfigs({ shouldRenderPipeForm: false, currentPipeConfig: null, editIndex: null });
  }, [onUpdatePipeConfigsToStore, onUpdatePipeFormConfigs]);

  const renderPipeView = useCallback((pipeConfig, idx) => {
    return (
      <PipeConfigView
        pipeConfig={pipeConfig}
        key={idx}
        isHiddenSignal={isHiddenSignal}
        currentPipeConfigIndex={idx}
        onEditPipeConfig={() => onEditPipeConfig(idx)}
        outputSchema={outputSchema}
        onDeletePipeConfig={() => onDeletePipeConfig(idx)}
        errorConfigs={errorConfigs}
      />
    );
  }, [isHiddenSignal, onDeletePipeConfig, onEditPipeConfig, outputSchema, errorConfigs]);

  const renderAddIndicatorButton = useMemo(() => {
    return (
      <button
        type="button"
        disabled={isHiddenSignal}
        className="btn btn-primary font-weight-semi d-flex align-items-center"
        onClick={() => {
          if (!isHiddenSignal) onAddIndicator();
        }}
      >
       <i className="fa-regular fa-square-plus"></i>
        <span className="ms-1">Add Indicator</span>
      </button>
    );
  }, [isHiddenSignal, onAddIndicator]);

  return (
    <div className="indicators-details ">
      <div className=" analysis-panel">
        <div className="selector-text">
          Indicators
        </div>
      </div>
      {_.map(pipeConfigs, renderPipeView)}
      {shouldRenderPipeForm && (
        <PipeConfigForm
          getPipeUpdatedNameIfAlreadyPresent={getPipeUpdatedNameIfAlreadyPresent}
          pipeConfig={currentPipeConfig}
          onUpdate={onUpdate}
          pipeIndex={_.isNumber(editIndex) ? editIndex : undefined}
          existingPipeNames={existingPipeNames}
        />
      )}
      <div className=" add-indicator__container">
        {isHiddenSignal ? (
          <HoverMessage message="This action has been disabled by the Author">
            {renderAddIndicatorButton}
          </HoverMessage>
        ) : (
          renderAddIndicatorButton
        )}
      </div>
    </div>
  );
};

PipeConfigs.propTypes = propTypes;
PipeConfigs.defaultProps = defaultProps;

export default PipeConfigs;
